<template lang="html">
  <div>
    <SoundslidesPlayer :path="path" :fillscreen="true" />
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer"
export default {
  name: "Fillscreen",
  components:{
    SoundslidesPlayer
  },
  data(){
    return {

    }
  },
  computed:{
    path(){
      var id = this.$route.params.id;
      if(id.length === 5){
        // Legacy hosting.
        return `https://s3.amazonaws.com/hosting.soundslides.com/${id}/`
      }else{
        return `https://s3.amazonaws.com/new.soundslides.hosting/${id}/`
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
